import addHighContrastStyles from '@/lib/styling/addHighContrastStyles';
import styled from '@emotion/styled';

type StyledThumbnailImageProps = {
  src: string;
};

const StyledThumbnailImage = styled('figure')<StyledThumbnailImageProps>(
  ({ theme, src }) => ({
    margin: 0,
    width: '100%',
    height: 80,
    backgroundImage: `url('${src}')`,
    backgroundColor: theme.palette.action.selected,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    borderRadius: 4,
  }),
  addHighContrastStyles(({ theme }) => ({
    border: `2px solid ${theme.palette.divider}`,
    boxSizing: 'border-box',
  })),
);

export default StyledThumbnailImage;
